import React from "react";
import TableNumberBase3 from "../TableNumberBase3";
import "./TableNumberBaseNull.css";

function TableNumberBaseNull() {
  return (
    <div className="table-number-base-null">
      <TableNumberBase3 />
    </div>
  );
}

export default TableNumberBaseNull;
